import React from 'react'
import { useI18n } from '../../i18n'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

type TimelineStep = {
  key: string
  status?: string
  labelKey?: string
}

interface Props {
  steps?: TimelineStep[]
}

export default function ExecutionTimeline({ steps = [] }: Props) {
  const { t } = useI18n()
  if (!steps.length) return null
  return (
    <ul className={wfStyles.timeline}>
      {steps.map((step) => (
        <li
          key={step.key}
          className={`${wfStyles.timelineStep} ${wfStyles[`timeline_${step.status || 'pending'}`] || ''}`}
        >
          <span className={wfStyles.timelineLabel}>
            {t(step.labelKey || `complianceExecution.timeline.${step.key.toLowerCase()}`, step.key)}
          </span>
          <span className={wfStyles.itemMeta}>{step.status || 'pending'}</span>
        </li>
      ))}
    </ul>
  )
}
